<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardHeader>
          <h4>Υποκατηγορίες</h4>
          <CButton color="primary" class="btn m-3 btn-primary" @click="createSubcategory()">Προσθήκη υποκατηγορίας</CButton>
        </CCardHeader>
        <CCardBody>
          <CModal
            class="modalAlert"
            :show.sync="alertIsShown"
            :centered="true"
            size="lg"
          >
            <CAlert
              closeButton
              :show.sync="alertIsShown"
              color="primary"
              fade
            >
              {{ message }}
            </CAlert>
          </CModal>
          <CDataTable
            :items="filteredItems"
            :fields="fields"
            :items-per-page="10"
            pagination
            column-filter
            table-filter
            hover
            striped
            :loading="loading"
            sorter
            @row-clicked="(item) => showSubcategory(item.id)"
            clickable-rows
          >
          <template #services-filter>
            <div class="selectFilter">
              <CSelect
                :options="servicesOptions"
                :value.sync="selectedIsoOption"
              />
            </div>
          </template>
          <template #active-filter>
            <div class="selectFilter">
              <CSelect
                :options="statusOptions"
                :value.sync="selectedOption"
              />
            </div>
          </template>
          <template #active="{item}">
            <td>
              <CBadge :color="getBadge(item.active)">{{ getBadgeText(item.active) }}</CBadge>
            </td>
          </template>
          <template #service="{item}">
            <td>
              {{ item.service }}
            </td>
          </template>
          <template #actions="{item}">
            <td class="button-cell">
              <CButton
                color="primary"
                class="btn-icon mr-2"
                @click.stop="editSubcategory( item.id )"
                v-c-tooltip="'Επεξεργασία'"
              >
                <CIcon name="cilPencil" />
              </CButton>
              <CButton
                v-if="you!=item.id"
                color="danger"
                class="btn-icon"
                @click.stop="deleteSubcategory( item.id )"
                v-c-tooltip="'Διαγραφή'"
              >
                <CIcon name="cilTrash" />
              </CButton>
            </td>
          </template>
        </CDataTable>
        </CCardBody>
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'

const fields = [
  { 
    key: 'name', 
    label: 'Όνομα'
  },
  { 
    key: 'service', 
    label: 'Πρότυπο ISO'
  },
  {
    key: 'active',
    label: 'Κατάσταση',
    sorter: false,
    filter: true
  },
  {
    key: 'actions',
    label: '',
    sorter: false,
    filter: false
  }
]

export default {
  name: 'Subcategories',
  data: () => {
    return {
      items: [],
      fields,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      you: null,
      message: '',
      selectedOption: 'Καμία επιλογή',
      statusOptions: ['Καμία επιλογή', 'Ενεργό', 'Ανενεργό'],
      selectedIsoOption: 'Καμία επιλογή',
      servicesOptions: ['Καμία επιλογή'],
      showMessage: false,
      dismissSecs: 7,
      alertIsShown: false,
      dismissCountDown: 0,
      loading: true,
      showDismissibleAlert: false
    }
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  },
  computed: {
    filteredItems() {
      if (this.selectedOption == "Καμία επιλογή" && this.selectedIsoOption == "Καμία επιλογή") {
        return this.items;
      }
      return this.items.filter(item => {
        const status = item.active == 1 ? 'Ενεργό' : 'Ανενεργό'
        const services = item.service;

        if (this.selectedOption == "Καμία επιλογή") {
          return services == this.selectedIsoOption;
        }

        if (this.selectedIsoOption == "Καμία επιλογή") {
          return status == this.selectedOption;
        }

        return status == this.selectedOption && services == this.selectedIsoOption;
      })
    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    getBadge (status) {
      return status === 1 ? 'success' : 'secondary'
    },
    getBadgeText (status) {
      return status === 1 ? 'Ενεργό' : 'Ανενεργό'
    },
    subcategoryLink (id) {
      return `subcategory/${id.toString()}`
    },
    editSubcategoryLink (id) {
      return `subcategory/${id.toString()}/edit`
    },
    showSubcategory ( id ) {
      const subcategoryLink = this.subcategoryLink( id );
      this.$router.push({path: subcategoryLink});
    },
    editSubcategory ( id ) {
      const editLink = this.editSubcategoryLink( id );
      this.$router.push({path: editLink});
    },
    deleteSubcategory ( id ) {
      let self = this;
      let userId = id;
      axios.post('/api/servicesubcategories/' + id + '?token=' + localStorage.getItem("api_token"), {
        _method: 'DELETE'
      })
      .then(function (response) {
          self.message = 'Επιτυχής διαγραφή υποκατηγορίας.';
          self.showAlert();
          self.getSubcategories();
      }).catch(function (error) {
        console.log(error);
        self.$router.push({ path: '/login' });
      });
    },
    createSubcategory () {
      this.$router.push({path: './create_subcategory'});
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
    getSubcategories (){
      let self = this;
      axios.get('/api/servicesubcategories?token=' + localStorage.getItem("api_token"))
      .then(function (response) {
        self.items = response.data.service_subcategory.map((item) => {
          item.service = item.service.name;
          return item;
        });
        self.you = response.data.you;
        self.loading = false;

        self.services = response.data.services;
        self.servicesOptions = ['Καμία επιλογή', ...self.services];
        self.selectedIsoOption = self.servicesOptions[0];
      }).catch(function (error) {
        console.log(error);
        self.loading = false;
        self.$router.push({ path: '/login' });
      });
    }
  },
  mounted: function(){
    this.getSubcategories();
  }
}
</script>
